import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCcVisa,
    faCcMastercard,
    faCcAmex
} from "@fortawesome/free-brands-svg-icons";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";

interface CardInputProps {
    card: string;
    setCard: (value: string) => void;
}

export const CardInput = ({ card, setCard }: CardInputProps) => {
    const [cardType, setCardType] = useState<string>("");

    const detectCardType = (number: string) => {
        const cleaned = number.replace(/\s+/g, "");
        if (/^4/.test(cleaned)) return "visa";
        if (/^(5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/.test(cleaned)) return "mastercard";
        if (/^3[47]/.test(cleaned)) return "amex";
        return "default";
    };

    const formatCardNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, "");
        if (/^3[47]/.test(cleaned)) {
            // Amex: 4-6-5
            return cleaned
                .replace(/(\d{4})(\d{0,6})(\d{0,5})/, (_, g1, g2, g3) =>
                    [g1, g2, g3].filter(Boolean).join(" ")
                )
                .trim();
        } else {
            // Visa/Mastercard: 4-4-4-4
            return cleaned.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
        }
    };

    const handleCardInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        value = formatCardNumber(value);
        setCard(value);
        setCardType(detectCardType(value));
    };

    const getCardIcon = () => {
        switch (cardType) {
            case "visa":
                return <FontAwesomeIcon icon={faCcVisa} className="text-primary" size="xl" />;
            case "mastercard":
                return <FontAwesomeIcon icon={faCcMastercard} className="text-danger" size="xl" />;
            case "amex":
                return <FontAwesomeIcon icon={faCcAmex} className="text-info" size="xl" />;
            default:
                return <FontAwesomeIcon icon={faCreditCard} className="text-secondary" size="xl" />;
        }
    };

    return (
        <div className="mb-3 col-md-12">
            <label htmlFor="card" className="form-label small text-muted mb-1">
                Número de tarjeta *
            </label>
            <div className="position-relative">
                <input
                    id="card"
                    name="card"
                    type="text"
                    inputMode="numeric"
                    autoComplete="cc-number"
                    className="form-control pe-5 onlyInteger"
                    placeholder="XXXX XXXX XXXX XXXX"
                    maxLength={cardType == 'amex' ? 17 : 19}
                    value={card}
                    onChange={handleCardInput}
                />
                <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                    style={{ pointerEvents: "none" }}
                >
                    {getCardIcon()}
                </span>
            </div>
        </div>
    );
};
